import {
    Button,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalFooter,
    ModalHeader,
    Select,
    ThemeColorVariable,
    ThemeSpaceVariable,
} from "@caspeco/casper-ui-library";
import { getNameOfCurrentLang } from "helpers/language-helper";
import i18n from "i18next";
import { trackEvent } from "logger/logger";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

export default function LanguageModal({
    isOpen,
    onClose,
}: {
    isOpen: boolean;
    onClose: () => void;
}) {
    const [value, setValue] = useState(i18n.language);
    const { t } = useTranslation();
    const handleSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setValue(e.target.value);
    };

    const onSave = async () => {
        const from = i18n.language;
        await i18n.changeLanguage(value).then(() => {
            // Only track if the language was actually changed
            if (from !== value) {
                trackEvent("LanguageChanged", { from, to: value });
            }

            // If the from language is the same as the to language, we may have bug
            if (from === value) {
                trackEvent("SameLanguageChange", { language: value });
            }
        });
        onClose();
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered>
            <ModalHeader
                pt={ThemeSpaceVariable.Medium}
                px={ThemeSpaceVariable.Medium}
                display="flex"
                justifyContent="space-between"
                minH="auto"
                color={ThemeColorVariable.OnSurfaceHeader}
            >
                {t("miscXLanguage", { 0: getNameOfCurrentLang() })}
                <ModalCloseButton />
            </ModalHeader>
            <ModalBody p={ThemeSpaceVariable.Medium}>
                <Select
                    id="languageSelect"
                    w="100%"
                    size="lg"
                    name="language"
                    onChange={handleSelect}
                    value={value}
                >
                    <option value="en">English</option>
                    <option value="sv">Svenska</option>
                    <option value="nb">Norsk</option>
                    <option value="da">Dansk</option>
                    <option value="fi">Suomi</option>
                    <option value="es">Español</option>
                    <option value="nl">Nederlands</option>
                    <option value="nl-BE">Nederlands (België)</option>
                    <option value="fr-FR">Français</option>
                    <option value="fr-BE">Français (Belgique)</option>
                    <option value="de">Deutsch</option>
                    <option value="de-BE">Deutsch (Belgien)</option>
                    <option value="et">Eesti</option>
                    <option value="lt">Lietuvių</option>
                    <option value="lv">Latviešu</option>
                </Select>
            </ModalBody>
            <ModalFooter
                pt={ThemeSpaceVariable.Medium}
                px={ThemeSpaceVariable.Medium}
                pb="calc(1em + env(safe-area-inset-bottom))"
                display="flex"
                gap={ThemeSpaceVariable.Medium}
                justifyContent="flex-end"
            >
                <Button
                    variant="primary"
                    onClick={() => void onSave()}
                    size={{ base: "lg", md: "md" }}
                >
                    {t("actionSave")}
                </Button>
            </ModalFooter>
        </Modal>
    );
}
